<template>
  <v-container fluid class="pa-3 mt-10">
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="6" xl="5">
        <div class="text-center mb-6">
          <v-icon size="64" color="#800000" class="mb-3">mdi-account-switch</v-icon>
          <h3 style="color: #800000" class="font-weight mb-2">Processo de Remoção e Lotação</h3>

          <v-divider class="mx-auto mt-1" style="max-width: 400px"></v-divider>
        </div>

        <v-card class="mt-1" outlined elevation="3" style="min-width: 100%">
          <v-card-title class="primary white--text d-flex align-center py-2">
            <v-icon left color="white">mdi-clipboard-check</v-icon>
            Status do Processo
          </v-card-title>
          <v-card-text class="pa-8">
            <div v-if="processoEmAndamento" class="text-center">
              <v-icon size="48" color="success" class="mb-4">mdi-check-circle</v-icon>
              <p class="headline font-weight-medium mb-4">Processo Ativo</p>
              <p class="body-1 mb-4"><strong>Digite seu CPF para fazer a inscrição</strong></p>
              <v-text-field
                label="CPF"
                outlined
                dense
                maxlength="14"
                prepend-icon="mdi-card-account-details-outline"
                v-model="cpfFormatado"
                @keyup.enter="validarServidor"
                placeholder="000.000.000-00"
                hint="Digite seu CPF"
                persistent-hint
                class="mx-auto mb-4"
                style="max-width: 300px"
              ></v-text-field>

              <v-btn color="success" large @click="validarServidor" :disabled="!cpf || cpf.length < 14" class="mt-2">
                <v-icon left>mdi-account-plus</v-icon>
                Confirmar Inscrição
              </v-btn>
            </div>
            <div v-else class="text-center">
              <v-icon size="48" color="grey" class="mb-4">mdi-clock-outline</v-icon>
              <p class="headline font-weight-medium mb-3">Aguardando</p>
              <p class="body-1 grey--text mb-4">Nenhum processo selecionado no momento.</p>
              <v-btn color="primary" class="mt-3" large @click="iniciarProcesso('Novo Processo')">
                <v-icon left>mdi-plus</v-icon>
                Iniciar Processo
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal de aguarde -->
    <v-dialog v-model="loading" persistent max-width="300">
      <v-card class="pa-6 d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate color="primary" size="48" class="mb-4" />
        <span class="subtitle-1 font-weight-medium">Aguarde...</span>
      </v-card>
    </v-dialog>

    <!-- Modal para mensagens importantes -->
    <v-dialog v-model="showModal" persistent max-width="350">
      <v-card class="pa-6 d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate color="primary" size="48" class="mb-4" />
        <span class="subtitle-1 font-weight-medium">{{ modalMessage }}</span>
      </v-card>
    </v-dialog>

    <!-- Snackbar para notificações -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="4000" top right>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false"> Fechar </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
//import { Libs } from "../../libs/libs";
// import filtros from "../../services/filters"; // arquivo não existe
import { mapGetters, mapMutations } from "vuex";
import RemocaoServices from "../../services/rh/RemocaoServices";
export default {
  name: "ProcessoAberto",
  data() {
    return {
      cpf: "",
      loading: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      modalMessage: "Aguarde...",
      showModal: false,
    };
  },
  // filters: filtros, // removido pois o arquivo não existe
  computed: {
    ...mapGetters({ processoEmAndamento: "remocao/processoSelecionado" }),
    cpfFormatado: {
      get() {
        return this.cpf;
      },
      set(valor) {
        // Remove tudo que não é dígito
        const numeros = valor.replace(/\D/g, "");
        // Aplica a máscara
        var formatado = numeros;
        if (numeros.length >= 4) {
          formatado = numeros.replace(/(\d{3})(\d)/, "$1.$2");
        }
        if (numeros.length >= 7) {
          formatado = formatado.replace(/(\d{3}\.\d{3})(\d)/, "$1.$2");
        }
        if (numeros.length >= 10) {
          formatado = formatado.replace(/(\d{3}\.\d{3}\.\d{3})(\d)/, "$1-$2");
        }
        this.cpf = formatado;
      },
    },
  },
  watch: {
    // Observa mudanças no processoEmAndamento
    processoEmAndamento: {
      handler(novoValor) {
        // Se não há processo em andamento, redireciona para initPage
        if (!novoValor) {
          this.$router.push({ name: "initPage" });
        }
      },
      immediate: true, // Executa imediatamente ao montar o componente
    },
  },
  methods: {
    ...mapMutations({
      setProcessoSelecionado: "remocao/setProcessoSelecionado",
      setDatasRemocao: "remocao/setDatasRemocao",
      setServidorSolicitante: "remocao/setServidorSolicitante",
    }),
    // Remove máscara para obter apenas números
    getCPFNumeros() {
      return this.cpf.replace(/\D/g, "");
    },
    // Valida CPF
    validarCPF(cpf) {
      cpf = cpf.replace(/\D/g, "");

      if (cpf.length !== 11) return false;
      if (/^(\d)\1{10}$/.test(cpf)) return false; // Sequências iguais

      let soma = 0;
      for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.charAt(9))) return false;

      soma = 0;
      for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
      }
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.charAt(10))) return false;

      return true;
    },
    // Métodos para mostrar notificações
    mostrarSucesso(mensagem) {
      this.snackbarText = mensagem;
      this.snackbarColor = "success";
      this.snackbar = true;
    },
    mostrarErro(mensagem) {
      this.snackbarText = mensagem;
      this.snackbarColor = "error";
      this.snackbar = true;
    },
    mostrarAviso(mensagem) {
      this.snackbarText = mensagem;
      this.snackbarColor = "warning";
      this.snackbar = true;
    },
    mostrarInfo(mensagem) {
      this.snackbarText = mensagem;
      this.snackbarColor = "info";
      this.snackbar = true;
    },
    // Método para inscrever no processo
    async validarServidor() {
      const cpfNumeros = this.getCPFNumeros();
      const ano = this.processoEmAndamento?.ano;

      if (!this.validarCPF(cpfNumeros)) {
        this.mostrarErro("CPF inválido! Por favor, digite um CPF válido.");
        return;
      }

      this.loading = true;
      try {
        this.mostrarInfo("Validando servidor...");
        const data = await RemocaoServices.validarServidor(cpfNumeros, ano);

        const { servidor, inscricao } = data;
        if (inscricao.pkinscricao) {
          this.modalMessage =
            "Você já está inscrito neste processo de remoção. Faça o login para acompanhar sua inscrição.";
          this.showModal = true;
          setTimeout(() => {
            this.showModal = false;
            this.modalMessage = "Aguarde...";
            this.$router.push({ name: "Login" });
          }, 4000);
          return;
        }
        if (!servidor?.id) {
          this.mostrarErro("Servidor não encontrado ou CPF inválido.");
          this.loading = false;
          return;
        }
        if (!inscricao?.id) {
          this.loading = false;
          this.setServidorSolicitante(servidor);
          this.$router.push({ name: "ProcessoRemocaoPreInscricao" });
        }
        // Aqui você pode adicionar a lógica para inscrever no processo
      } catch (error) {
        this.loading = false;
        console.error("Erro ao validar servidor:", error);
        this.mostrarErro("Erro ao validar servidor. Tente novamente.");
      } finally {
        this.loading = false;
      }
    },
    // Exemplo de método que usa as mutations
    iniciarProcesso(processo) {
      // Criar um objeto com estrutura adequada
      const processoCompleto = {
        id: Date.now(), // ID temporário
        nome: processo,
        ano: new Date().getFullYear(), // Ano atual
        status: "ativo",
        dataInicio: new Date().toISOString(),
      };

      this.setProcessoSelecionado(processoCompleto);
    },
  },
  mounted: function () {
    // Exemplo de inicialização

    // Verifica se há processo em andamento ao montar
    if (!this.processoEmAndamento) {
      this.$router.push({ name: "initPage" });
    }
  },
};
</script>
